import CryptoJS from 'crypto-js';

/** Base64 Content-MD5 for S3 presigned PUT (Object Lock buckets require it on upload). */
export default async function computeContentMd5Base64(file) {
  const buffer = await file.arrayBuffer();
  const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(buffer));
  return CryptoJS.enc.Base64.stringify(CryptoJS.MD5(wordArray));
}
